import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { QueueBatch, QueueBatchDetailed } from '../interfaces/queue-batch.interface';
import { Observable } from 'rxjs';
import { QueueBatchItem } from '../interfaces/queue-batch-item.interface';

@Injectable({
	providedIn: 'root',
})
export class QueueBatchItemService {
	readonly url: string = 'queueBatchItem';

	constructor(private http: HttpClient) {}

	public getQueueBatchItemsByQueueBatchId(queueBatchId: number): Observable<QueueBatchItem[]> {
		return this.http.get<QueueBatchItem[]>(`${this.url}/getQueueBatchItemsByQueueBatchId/${queueBatchId}`);
	}
}
